<template>
<v-menu bottom right :offset-y="true" max-height="150">
    <template v-slot:activator="{ on }">
        <v-text-field v-on="on" @click.native="edit=true; getItems()" :filled="edit" icon v-model="model" @input="emitInput()" class="search">
            <v-icon>more_vert</v-icon>
        </v-text-field>

    </template>

    <v-list>
        <v-list-item v-for="(item, i) in items" :key="i" @click="">
            <v-list-item-title :class="[(i == position)? 'red--text': '']">{{ item }}</v-list-item-title>
        </v-list-item>
    </v-list>
</v-menu>
</template>

<script>
export default {
    data() {
        return {
            edit: false,
            model: this.item,
            items: [],
            loading: false,
            search: null,
            platform: {},
            position: null,
        }
    },
    props: {
        item: String,
        app_slug: String,
        app_id: [Number, String]
    },
    created() {
        // this.getItems();
    },

    watch: {

        app_slug() {
            this.getItems();
        },

        item() {
            this.getItems();
            this.model = this.item;
        },

        model() {
            this.getItems();
        },

        app_id() {
            if(this.app_id) {
                this.getPlatform();
            }
        }

    },

    methods: {

        clean() {
            this.edit = false;
        },

        getItems() {

            let slug = null;

            if(this.app_id || this.app_slug) {
                if(this.app_slug) {
                    slug = this.app_slug;
                } else {
                    slug = this.platform.slug;
                }
            } else {
                return;
            }
            // loading
            this.loading = true;
            this.position = null;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/translations/identifiers/slugs/' + slug;

            // prepare params
            let options = {
                params: {
                    search: this.model
                }
            };

            // make places search request
            this.$axios.get(endpoint, options)
                .then(response => {
                    this.items = response.data;
                    this.items.forEach(function (item, index) {
                        if(this.model === item) {
                            this.position = index;
                        }
                    }.bind(this))

                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });

        },

        getPlatform() {
            if(!this.app_id) {
                return
            }

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/translations/platforms/' + this.app_id;

            this.$axios.get(endpoint)
                .then(response => {
                    this.platform = response.data;
                    this.getItems();
                })
                .catch(error => {
                    console.log(error);
                    this.error('Oops, something went wrong!');
                })
                .finally(() => {
                    this.loading = false;
                })
        },

        emitInput() {
            this.$emit('input', this.model);
            this.$emit('update:item', this.model);
        },
    }
}
</script>

<style>
.search.v-input .v-input__control .v-input__slot .v-text-field__slot input {
    margin-top: 0 !important;
}

.search.v-input .v-input__control .v-input__slot {
    min-height: 30px;
}

.search.v-input .v-input__control .v-text-field__details {
    display: none;
}

.search.v-text-field {
    margin: 0px !important;
    padding: 0px !important;
}
</style>
